var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { cloneElement } from 'react';
import clsx from 'clsx';
import { getValidChildren } from '../utils/index.js';
export const ButtonGroup = props => {
    const { size = 'md', className, children } = props, rest = __rest(props, ["size", "className", "children"]);
    const variant = 'outline';
    const validChildren = getValidChildren(children);
    const clones = validChildren.map(child => {
        const childProps = {
            variant,
            size,
            className: 'rounded-s-none rounded-e-none  first:rounded-s-md last:rounded-e-md -ms-px  focus:z-10',
        };
        return cloneElement(child, childProps);
    });
    return (React.createElement("span", Object.assign({ className: clsx('relative isolate z-0 inline-flex shadow-sm rounded-md', className) }, rest), clones));
};
//# sourceMappingURL=ButtonGroup.js.map